import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'date-and-price-section';
const BLOCK_ID = 'date-and-price-section';
const PLACEHOLDER_LABEL = 'Datum & Preis';

export default function dateAndPriceSection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-date-and-price-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: 'Datum & Preis',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-date-and-price',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'select',
                        label: 'Darstellung',
                        name: 'displayType',
                        options: [
                            {
                                name: 'Kalender',
                                value: 'calendar',
                            },
                            {
                                name: 'Liste',
                                value: 'list',
                            },
                        ],
                        default: 'calendar',
                        changeProp: 1,
                    },
                ],
            },
        },
        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Datum & Preis',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H5V9h14v11Zm-9-7H7v-2h3v2Zm4 0h-2v-2h2v2Zm4 0h-2v-2h2v2Zm-8 4H7v-2h3v2Zm4 0h-2v-2h2v2Zm4 0h-2v-2h2v2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-date-and-price',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
